import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../App';
import { CheckText } from '../../components/common/CheckText';
import { Flexed } from '../../styles/GlobalComponents';
import { PackageRankMyProgressModel } from './Ranking.types';

export const QualifiedPartner = ({
  rank
}: {
  rank: PackageRankMyProgressModel;
}) => {
  const { t } = useTranslation('ranking');

  if (rank.name === 'Qualified Partner') {
    return (
      <>
        <Desktop>
          <Flexed between mbSM='20'>
            <CheckText
              text={t('qualified_partner.text1')}
              checked={rank.isRegisteredMember}
            />

            <CheckText
              text={t('qualified_partner.text2')}
              checked={rank.hasPaidHub}
            />
            <CheckText
              text={t('qualified_partner.text4')}
              checked={rank.hasPartnerWithPaidPackageInLeftLeg}
            />
            <CheckText
              text={t('qualified_partner.text3')}
              checked={rank.hasPartnerWithPaidPackageInRightLeg}
            />
          </Flexed>
        </Desktop>
        <Mobile>
          <Flexed column gap='20px' mbSM='20'>
            <CheckText
              text={t('qualified_partner.text1')}
              checked={rank.isRegisteredMember}
            />
            <CheckText
              text={t('qualified_partner.text2')}
              checked={rank.hasPaidHub}
            />
            <CheckText
              text={t('qualified_partner.text3')}
              checked={rank.hasPartnerWithPaidPackageInRightLeg}
            />
            <CheckText
              text={t('qualified_partner.text4')}
              checked={rank.hasPartnerWithPaidPackageInLeftLeg}
            />
          </Flexed>
        </Mobile>
      </>
    );
  } else return null;
};
